import React, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ScheduleBatch from "../ScheduleBatch/ScheduleBatch";
import HistoryTab from "../HistoryTab/HistoryTab";
import NcsPayrollReview from "../NcsPayrollReview/NcsPayrollReview";
import "./BatchTabs.scss";

// Custom Tab Panel, this is from MUI
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        backgroundColor: "white",
      }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BatchTabs({
  batchList,
  getNewBatchList,
  userPermissions,
}) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }} className="batch-tab-container">
      <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
        {/* Styling for the tabs */}
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "capitalize",
              color: "#BCBCBC",
              fontFamily: "Inter",
              fontSize: 15,
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "30px",
              backgroundColor: "#f8f8f8",
              width: "178px",
              "&.Mui-selected": {
                backgroundColor: "white",
                color: "#5523D2",
                borderRadius: "6px 6px 0 0 !important",
                textAlign: "center",
                fontSize: 15,
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                borderBottom: 0,
                borderBottomColor: "#FAC800",
                borderBottomWidth: 4,
              },
            },
          }}
        >
          <Tab label="Scheduler" {...a11yProps(0)} />
          <Tab label="Review" {...a11yProps(1)} />
          <Tab label="History" {...a11yProps(2)} />  
        </Tabs> 
      </Box>{" "}
      <CustomTabPanel value={value} index={0}>
        <ScheduleBatch
          batchList={batchList}
          userPermissions={userPermissions}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <div className="history-tab-styling">
          <HistoryTab batchList={batchList} userPermissions={userPermissions} />
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <NcsPayrollReview />
      </CustomTabPanel>
    </Box>
  );
}
